var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showNbFooter)?_c('pvd-footer',{attrs:{"us-only":_vm.usOnlyText,"links":_vm.content}},[_c('net-benefits-footer')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }